// Service Comms — customer-reminders outbox. Mirrors api/dvi.ts's fetch idiom
// exactly (readCookie/csrfHeaders/j<T>): the two POSTs (commsScan, commsResend)
// send CSRF headers; the two GETs don't need them.
import type { Reminder } from './types';

function readCookie(name: string): string | null {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}
function csrfHeaders(): Record<string, string> {
  const h: Record<string, string> = { 'Content-Type': 'application/json' };
  const c = readCookie('pacebi_csrf');
  if (c) h['X-CSRF-Token'] = c;
  return h;
}
async function j<T>(res: Response): Promise<T> {
  if (!res.ok) {
    if (res.status === 404) throw new Error('404: módulo de comunicaciones no habilitado');
    throw new Error(`comms failed: ${res.status}`);
  }
  return (await res.json()) as T;
}

export async function fetchReminders(kind?: string, status?: string): Promise<Reminder[]> {
  const q = new URLSearchParams({ kind: kind ?? '', status: status ?? '' });
  return j(await fetch(`/api/comms/reminders?${q.toString()}`, { credentials: 'same-origin' }));
}
export async function fetchReminder(id: string): Promise<Reminder> {
  return j(await fetch(`/api/comms/reminders/${id}`, { credentials: 'same-origin' }));
}
export async function commsScan(): Promise<{ enqueued: number; flushed: number }> {
  return j(await fetch('/api/comms/scan', { method: 'POST', credentials: 'same-origin', headers: csrfHeaders() }));
}
export async function commsResend(id: string): Promise<Reminder> {
  return j(await fetch(`/api/comms/reminders/${id}/resend`, { method: 'POST', credentials: 'same-origin', headers: csrfHeaders() }));
}
